import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, Observer } from 'mobx-react';
import { Icon } from '@99designs/common/components/Icon';
import { IconButton } from '@99designs/common/components/IconButton';
import { FilterGroup } from 'apps/find-designers/propTypes';
import CheckableFilterOption from './CheckableFilterOption';
import Accordion from '../Accordion';

class GroupedCheckboxFilter extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    getToggledValue(value, checked, options) {
        let updatedOptions = options;
        if (checked) {
            if (this.props.filter.isParentOption(value)) {
                const parent = this.props.filter.options.find(
                    option => option.parentOption.value === value
                );
                updatedOptions = updatedOptions.filter(
                    option => !parent.childOptions.some(child => child.value === option)
                );
            } else if (this.props.filter.isChildOption(value)) {
                const parent = this.props.filter.getParentOfChild(value);
                updatedOptions = updatedOptions.filter(option => option !== parent.value);
            }
            updatedOptions = updatedOptions.concat(value);
        } else {
            updatedOptions = updatedOptions.filter(option => option !== value);
        }
        return updatedOptions;
    }

    handleChange(e) {
        const { name, value, checked } = e.target;

        this.props.onChange(
            name,
            this.getToggledValue(value, checked, [...this.props.filter.value])
        );
    }

    parentOption(option, isOpen, onToggle) {
        return (
            <div className="grouped-checkbox-filter">
                <div className="grouped-checkbox-filter__parent-option">
                    <CheckableFilterOption
                        filterOption={option.parentOption}
                        isChecked={this.props.filter.value.includes(option.parentOption.value)}
                        key={option.parentOption.id}
                        type={'checkbox'}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="field field--inline">
                    <IconButton onClick={onToggle}>
                        {!isOpen && <Icon variations={['down-2']} />}
                        {isOpen && <Icon variations={['up-2']} />}
                    </IconButton>
                </div>
            </div>
        );
    }

    childOptions(option) {
        return option.childOptions.map(child => (
            <CheckableFilterOption
                filterOption={child}
                isChecked={this.props.filter.value.includes(child.value)}
                key={child.id}
                type={'checkbox'}
                onChange={this.handleChange}
            />
        ));
    }

    groupedCheckboxes(option, isOpen, onToggle) {
        return (
            <div>
                {this.parentOption(option, isOpen, onToggle)}
                <div
                    className={`grouped-checkbox-filter__child-options ${
                        !isOpen ? 'grouped-checkbox-filter__child-options--closed' : ''
                    }`}
                >
                    {this.childOptions(option, isOpen)}
                </div>
            </div>
        );
    }

    render() {
        return this.props.filter.options.map(option => (
            <div key={option.parentOption.id}>
                <Accordion
                    isOpen={option.hasAnySelectedChildOption(this.props.filter.selectedOptions)}
                >
                    {({ isOpen, onToggle }) => (
                        <Observer>
                            {() => this.groupedCheckboxes(option, isOpen, onToggle)}
                        </Observer>
                    )}
                </Accordion>
            </div>
        ));
    }
}

GroupedCheckboxFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    filter: FilterGroup.isRequired,
};

export default observer(GroupedCheckboxFilter);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/GroupedCheckboxFilter.jsx